import React, {useState, useRef} from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import withRipple from 'jd-library/withRipple';
import FileSelector from '../../common/FileSelector';
import { connect, useDispatch } from 'react-redux';
import { uploadMultipleFile } from '../../common/productImageUtils';
import { setRedirectedFrom, getVendorImages, setVendorImages, markPreviouslyUploadedFiles, setTabStatus, setPreviousTabIndex, activateBrochureTab, clickTrack, updateEditProductDetail, getProductData, saveAddEditProduct, fetchCountryCode, hideProductEditSlider, toggleAICreationModal } from '../../actions/products';
import { updateBrandManufactureDetails, handleOnChange, updateSpecificationData } from '../../actions/productSpecification';
import { toggleUploadOptions, uploadImageFromLink } from '../../actions/upload-options';
import { updateItemImage } from '../../actions/items';
import { useHistory } from 'react-router-dom';
import { setRouteChangeMessage } from '../../utills';
import { getImagePath } from '../../common/productImageUtils';
import { toggleGalleryModal,togglePhotoSlider } from '../../actions/photosGallery';
import { showToastMessage } from '../../actions/toastmessage';
import { showHideLoader } from '../../actions';
import AnimateButton from 'jd-library/AnimateButton';
import PhotoSlider from '../photo-slider/PhotoSlider';
import { uploadPhotoFromApp } from '../photo-slider/photoSliderUtills'
import AddDCButton from '../../common/AddDCButton';
import NoProductServiceIdeal from '../add-edit-product/NoProductServiceIdeal/NoProductServiceIdeal';
import { setCurrentStep } from '../../actions/bulkUpload';
import UblcsModal from '../../common/Ublcs-modal';
import AIAssistantModal from '../add-edit-product/ai-assistant/AIAssistantModal';
import { fetchAiSpecSuggestions } from '../add-edit-product/product-specification/productSpecifications.utils.js';

const AddPhotoProdButton = props => {
    const [showOptions, setShowOptions] = useState(false);
    const [ublcsModal, toggleUblcsModal] = useState(false);
    const [showAIAssistant, setShowAIAssistant] = useState(false);
    const isOwner = props.session.user.loggedUser && props.session.user.loggedUser.userType == "OWNER";
    const fileSelector = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();
    // Cache: categoryName → Promise<{ cat, specsData }>
    const bgSpecsCacheRef = useRef({});
    const streamDoneRef = useRef(false);
    const pendingSuggestionsRef = useRef(null);
    // Buffer for all AI-collected data — applied to form when user clicks Save Product or Edit Product
    const bufferedRef = useRef({ productName: null, catData: null, fieldFills: [], specs: null, specSuggestions: null, images: null });
    const formOpenedByAIRef = useRef(false);

    const handleOptionClick = (type) => {
        
        if (props.session.isReadOnly){
            ublcsModalHandler()
            return;
        }
        switch(type) {
            case 'addProduct': {
                if(!props.session.viaOmni) 
                    dispatch(clickTrack({li: 'dc_addprod', ll: 'digital_catalog',userBasedCheck: true}))
                setShowOptions(false);              
                props.redirectToAddProduct('product');
            }
            break;

            case 'addService': {
                if(!props.session.viaOmni)
                    dispatch(clickTrack({li: 'dc_addsvc',ll: 'digital_catalog', userBasedCheck: true}))
                setShowOptions(false);
                props.redirectToAddProduct('service');
            }
            break;

            case 'brochure': {
                dispatch(clickTrack({li: 'dc_addbrochure', ll: 'digital_catalog',userBasedCheck: true}))
                setShowOptions(false); 
                setForBrochure(true) ;
                fileSelector.current.triggerClick(true)
            }
            break;

            case 'photos': {
                uploadImage();
            }
            break;

            case 'bulkUpload': {
                if(!props.session.viaOmni)
                    dispatch(clickTrack({li: 'dc_bulkupload',ll: 'digital_catalog', userBasedCheck: true}))
                setShowOptions(false);
                if(props.session.user.loggedUser.subType == "OBE" && (props.session.bulkUploadProfile)){
                    props.setCurrentStep({currentStep: 3})
                }
                props.openBulkUploadSlider(true);
            }
            break;

            case 'jdGallery': {
                dispatch(clickTrack({li: 'dc_addjdgallery',ll: 'digital_catalog', userBasedCheck: true}))
                props.redirectToJdPhotos();
                setTimeout(() => {
                    setShowOptions(false);
                })
            }
            break;

            case 'aiAssistant': {
                setShowOptions(false);
                if (!props.countryList?.length) dispatch(fetchCountryCode());
                setShowAIAssistant(true);
            }
            break;
        }
    }

    const ublcsModalHandler = () => {
		toggleUblcsModal(true);
	};
    
    const uploadImage = () => {
        if(!props.session.viaOmni)
            dispatch(clickTrack({li: 'dc_addphotos',ll: 'digital_catalog', userBasedCheck: true}))
        if(window.jdInterface){
            uploadPhotoFromApp(props, ()=>{
                setRouteChangeMessage({
                    message: `Photo Added Successfully`
                });
                history.push('/products/photos')
            });
        }else{
            fileSelector.current.triggerClick(true);
        }
        setShowOptions(false);
    }

    const onFileChange = (e) => {
        const fileLength = e.target.files.length
        let tempArr = [...props.vendorImages];
        let messageSet = false;
        props.showHideLoader({
            showLoader: true
        })
        uploadMultipleFile({
            imageUrlArr: [],
            data: e.target.files,
            variantId: '',
            productId: '',
            isMobile: props.isMobile,
            showToastMessage: props.showToastMessage,
            imgUploadUrl: '/vendorapis/products/image/uploadProductImageForLibrary',
            uploadedFrom: 'image',
            updateImage: (res) => {
                if(res.uploaded && res.imgURL){
                    for(let i=tempArr.length-1;i>=0;i--){
                        if(tempArr[i].imgIndex == res.imgIndex){
                            tempArr[i] = {
                                actualPath: res.actualPath,
                                imageUrl: res.imgURL,
                                uploaded: res.uploaded,
                                finalImageSrc: getImagePath(res.imgURL),
                                galleryId: res.galleryId
                            }
                        }
                    }
                    if(!messageSet){
                        props.showHideLoader({
                            showLoader: false
                        })
                        setRouteChangeMessage({
                            message: `${res.noOfFilesToUpload > 1 ? res.noOfFilesToUpload+' Photos' : 'Photo'} Added Successfully`
                        })
                        messageSet = true;
                        if(props.isMobile){
                            history.push('/products/photos');
                        }else{
                            props.togglePhotoSlider({
                                selectPhotoSlider: true
                            })
                        }
                        if(res.noOfFilesToUpload === 1){
                            setTimeout(() => {
                                props.toggleGalleryModal({
                                    selectedImages:  [0],
                                    addModal: {
                                        show: true
                                    }
                                })
                            }, 250)
                        }
                    }
                    props.setVendorImages([...tempArr]);
                }else if(res.base64Url){
                    tempArr.unshift(res);
                    props.setVendorImages([...tempArr]);
                }
            },
            onErrorCB: ()=>{
                props.showHideLoader({
                    showLoader: false
                })
            }
        })
    }
    const isContractor = (props.user?.loggedUser?.subType == 'CONTRACTOR');
    const isContractorV2 = (props.user?.loggedUser?.subType == 'CONTRACTORV2');
    const isContractorV3 = (props.user?.loggedUser?.subType == 'CONTRACTORV3');
    const contractProfile = Number(props.session?.newProfile);
    const profileObject = props?.session?.profileObject
	const isObeFromSSO = props.session.user?.loggedUser?.subType == "OBE";
    const isContractorProfile = isContractor || isContractorV2 || isContractorV3;
    const [isBrochure,setForBrochure] = useState(false);
    const iconData = useRef([
        (profileObject.isRE || profileObject.isSO || props.session?.viaOmni) && {
        label: 'Add Product',
        iconClass: 'icon-Add_product',
        iconAction: ()=> handleOptionClick('addProduct')
    }, (profileObject.isSer || props.session?.viaOmni) && {
        label: 'Add Service',
        iconClass: 'icon-Add_service',
        iconAction: ()=> handleOptionClick('addService')
    }, (!props.session?.viaOmni) && {
        label: `Add ${props.session.brochureButton ? props.session.brochureButton : 'Brochure'}`,
        iconClass: "icon-Brochure",
        iconAction: ()=> handleOptionClick('brochure')
    }, {
        label: "Add Photos",
        iconClass: "icon-CameraOutline",
        iconAction: () => handleOptionClick('photos')
    }, (isOwner || (isObeFromSSO && props.session.bulkUploadProfile)) && {
        label: `Bulk Upload  ${(isObeFromSSO && props.session.bulkUploadProfile) ? 'Service' : profileObject.SingleLabelWithSpace}`,
        iconClass: 'icon-glimport',
        iconAction: ()=> handleOptionClick('bulkUpload')
    }, (!props.session?.viaOmni) && {
        label: `Add ${profileObject.SingleLabelWithSpace} from Jd Gallery`,
        iconClass: "icon-myImages",
        iconAction: ()=> handleOptionClick('jdGallery')
    }, !(props.session?.viaOmni) && {
        label: 'AI Assistant',
        iconClass: 'icon-magicWand',
        iconAction: () => handleOptionClick('aiAssistant')
    }])

   
    

    const validMimeType = [
		'application/pdf','image/png', 'image/jpeg', 'image/jpg', 'image/webp'
    ]

	const validExtensions = [
		".pdf",".png",".jpg",".webp"
	]
    const accept = [
		...validMimeType,
		...validExtensions
	]

const markPreviouslyUploadedFiles = () => {
    if(props.fileAttachmentArr.length > 0){
        // props.cancelPendingFiles({productId: props.productId});
       props.markPreviouslyUploadedFiles({productId: props.productId});
    }
}

const validFiles = props.fileAttachmentArr.filter(cur => {
    return ((cur.uploading || cur.uploaded) && !cur.isDeleted)
});

const onChangeBrochure = async (e) => {
    const { target : { files } } = e;
    const { brochureFileHandling } = await import('./brochurelisting.utils');
    try {
        const uploadedFiles = await brochureFileHandling(files, props.tabKey);
        setTimeout(() => {
            props.activateBrochureTab();
            props.setTabStatus({ tabKey: 'brochure' });
            props.setPreviousTabIndex({ tabIndex: 1 });
        }, 400);
        if (props.session?.newProfile != 3 && uploadedFiles && uploadedFiles.length) {
            props.toggleAICreationModal({brochureUploadModal: {show: true,uploadedFiles}});
        }
    } catch(err){
        console.error(err);
    }
}
    // ── AI chatbot step-by-step callbacks ──────────────────────────────────

    // Step 1: User submitted product name → buffer only (form opens when user clicks Edit Product or Save Product)
    const handleAIProductNameSet = (name) => {
        bufferedRef.current = { productName: name, catData: null, fieldFills: [], specs: null, specSuggestions: null, images: null };
        formOpenedByAIRef.current = false;
        bgSpecsCacheRef.current = {};
        streamDoneRef.current = false;
        pendingSuggestionsRef.current = null;
    };

    // Flatten a spec value that might be a nested object from the AI response
    const flattenSpecValue = (v) => {
        if (v === null || v === undefined) return '';
        if (typeof v !== 'object') return String(v);
        const primitives = Object.values(v).filter(x => typeof x === 'string' || typeof x === 'number');
        return primitives.join(', ') || '';
    };

    const findCountry = (value) => {
        const list = props.countryList || [];
        return list.find(c => c.countryName?.toLowerCase() === String(value).toLowerCase())
            || (value ? { countryCode: String(value).substring(0, 2).toUpperCase(), countryID: 1, countryName: String(value), isdCode: 91 } : null);
    };

    const buildBaseUpdates = (buffer, description) => {
        const updates = [
            { key: 'productId',    value: 'ADD_PRODUCT' },
            { key: 'fillByAI',     value: true },
            { key: 'bizSuggestion', value: { data: [{ bizType: 'Retailer', natCatId: 'Retailer' }, { bizType: 'Wholesaler', natCatId: 'Wholesaler' }, { bizType: 'Exporter', natCatId: 'Exporter' }, { bizType: 'Manufacturer', natCatId: 'Manufacturer' }] } },
        ];
        if (buffer.productName) updates.push({ key: 'productName', value: buffer.productName });
        if (buffer.catData?.cat) {
            const { cat } = buffer.catData;
            updates.push(
                { key: 'keywordId',    value: cat.id },
                { key: 'leafId',       value: cat.psv_node_id },
                { key: 'categoryName', value: cat.psv_node_name },
                { key: 'keywordName',  value: cat.name },
                { key: 'psv_node_id',  value: cat.psv_node_id },
            );
        }
        if (buffer.images?.length) {
            const localImages = buffer.images.filter(img => img.imageUrl).map((img, idx) => ({
                imgURL: img.imageUrl,
                actualPath: img.displayUrl || getImagePath(img.imageUrl),
                uploaded: true,
                imgIndex: Date.now() + idx,
                jdGalleryImage: true,
            }));
            if (localImages.length) updates.push({ key: 'imageUrlArr', value: localImages });
        }
        if (description) updates.push({ key: 'description', value: description });
        return updates;
    };

    const getMappedUnmapped = (buffer) => ({
        mapped:   buffer.catData?.mapped?.length   ? buffer.catData.mapped   : (buffer.specs?.mapped   || []),
        unmapped: buffer.catData?.unmapped?.length ? buffer.catData.unmapped : (buffer.specs?.unmapped || []),
    });

    const dispatchImages = (images, onAllDone = null) => {
        const externalImages = images.filter(img => !img.imageUrl);
        if (!externalImages.length) {
            if (onAllDone) onAllDone();
            return;
        }
        dispatch((dispatchFn) => {
            dispatchFn(toggleUploadOptions({ data: { productId: 'ADD_PRODUCT', ignoreSave: true } }));
            let remaining = externalImages.length;
            const onOne = () => { if (--remaining <= 0 && onAllDone) onAllDone(); };
            externalImages.forEach(img => dispatchFn(uploadImageFromLink({ link: img.displayUrl, isAddProductPage: true }, onOne)));
        });
    };

    const dispatchBrandManuf = (brandManuf) => {
        if (!brandManuf.brandName && !brandManuf.manufacturer && !brandManuf.manufactured_details) return;
        dispatch((dispatchFn, getState) => {
            const bMdetails = getState().brandManufacturer || {};
            const sendDetails = [];
            if (brandManuf.brandName)             sendDetails.push({ name: 'brand',                values: [brandManuf.brandName] });
            if (brandManuf.manufacturer)          sendDetails.push({ name: 'manufacturer',         values: [brandManuf.manufacturer] });
            if (brandManuf.manufactured_details)  sendDetails.push({ name: 'manufactured_details', values: [brandManuf.manufactured_details] });
            dispatchFn({ type: 'UPDATE_BRAND_MANUFACTURE_DATA', payload: { ...bMdetails, productId: 'ADD_PRODUCT', brandName: brandManuf.brandName, manufacturer: brandManuf.manufacturer, manufactured_details: brandManuf.manufactured_details, sendDetails } });
        });
    };

    // Fetch AI-generated values for unfilled mandatory specs of the selected category.
    // Skips specs already provided by the user via detail-card field fills.
    const getSpecsFromAI = async (specsData, productName, categoryName) => {
        const SKIP_TYPES = new Set(['fixed']);
        const SKIP_KEYS  = new Set([
            'brand','manufacturer','manufactured_details','country_of_origin',
            'importer','importers_detail','price','mrp','net_weight',
            'packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date',
        ]);

        // Collect spec IDs already filled via detail-card field fills
        const alreadyFilledSids = new Set(
            (bufferedRef.current.fieldFills || [])
                .filter(f => f.fieldKey.startsWith('spec_'))
                .map(f => String(f.fieldKey.replace('spec_', '')))
        );

        // Collect spec names already filled via confirmed spec suggestions
        const alreadySuggestedNames = new Set(
            (bufferedRef.current.specSuggestions || []).map(s => (s.name || '').toLowerCase())
        );

        const unfilledMandatorySpecs = specsData
            .filter(s =>
                (Number(s.s_mandatory) || Number(s.s_re_mandatory)) &&
                !SKIP_TYPES.has((s.s_type || '').toLowerCase()) &&
                !SKIP_KEYS.has((s.s_nm  || '').toLowerCase()) &&
                !alreadyFilledSids.has(String(s.s_id)) &&
                !alreadySuggestedNames.has((s.s_dnm || s.s_nm || '').toLowerCase())
            )
            .map(s => ({
                s_id:           s.s_id,
                name:           s.s_dnm || s.s_nm,
                s_type:         s.s_type         || 'textbox',
                s_type_options: s.s_type_options  || [],
                s_unit:         s.s_unit          || '',
                s_regexp:       s.s_regexp        || '',
            }));

        if (!unfilledMandatorySpecs.length) return { mapped: [], unmapped: [], unfilledMandatory: [] };

        try {
            const res = await fetch('/internal-apis/getSpecsFromAI', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ productName, categoryName, mandatorySpecs: unfilledMandatorySpecs }),
            });

            const toUnfilled = (s) => ({ sid: s.s_id, name: s.name, s_type: s.s_type, s_type_options: s.s_type_options, s_unit: s.s_unit, s_regexp: s.s_regexp });
            if (!res.ok) return { mapped: [], unmapped: [], unfilledMandatory: unfilledMandatorySpecs.map(toUnfilled) };

            const data = await res.json();
            if (!data.isSuccess) return { mapped: [], unmapped: [], unfilledMandatory: unfilledMandatorySpecs.map(toUnfilled) };

            const filledValues = data.results || {};
            const mapped = [];
            const unfilledMandatory = [];

            unfilledMandatorySpecs.forEach(specMeta => {
                const rawValue = filledValues[specMeta.name];
                if (!rawValue) {
                    unfilledMandatory.push(toUnfilled(specMeta));
                    return;
                }
                mapped.push({
                    sid:            specMeta.s_id,
                    value:          String(rawValue),
                    catKey:         specMeta.name,
                    s_type:         specMeta.s_type,
                    s_type_options: specMeta.s_type_options,
                    s_regexp:       specMeta.s_regexp,
                    s_unit:         specMeta.s_unit,
                });
            });

            return { mapped, unmapped: [], unfilledMandatory };
        } catch (e) {
            console.error('[getSpecsFromAI error]', e);
            return { mapped: [], unmapped: [], unfilledMandatory: [] };
        }
    };

    // Shared: fetch category + specs for a given category name — returns { cat, specsData }
    const fetchCategorySpecs = async (categoryName, isService = false) => {
        const token = props.session.token;
        const supplierId = props.supplierId;
        const serviceFlag = isService ? 1 : 0;
        try {
            const catRes = await fetch(
                `/vendorapis/products/product/fetchTemplateProductsBySearchTerm?limit=5&page=1&srchterm=${encodeURIComponent(categoryName)}&type=2&sort=pop&token=${token}&service=${serviceFlag}`
            ).then(r => r.json()).catch(() => null);

            if (!catRes?.[0]) return { cat: null, specsData: [] };
            const cat = catRes[0];

            const specsRes = await fetch(
                `/vendorapis/products/product/fetchProductSpecsData?keywordid=${cat.id}&display_Flag=1&token=${token}&supplierId=${supplierId}`
            ).then(r => r.json()).catch(() => null);

            const rawSpecs = Array.isArray(specsRes?.data) ? specsRes.data : [];
            return { cat, specsData: rawSpecs, categoryStatus: specsRes?.category_status };
        } catch {
            return { cat: null, specsData: [] };
        }
    };

    // Fetch category images from imageListing API and fire ai-images-ready event
    const fetchCategoryImages = async (keywordId) => {
        const token = props.session.token;
        try {
            const res = await fetch(
                `http://omegamarketplace.justdial.com/marketplace/static/php/web/b2bWebsite.php?action=imageListing&pageNo=1&keyword_id=${keywordId}&token=${token}`
            ).then(r => r.json()).catch(() => null);
            const images = (res?.results || []).map((img, idx) => ({
                id: img.id ?? idx,
                imageUrl: img.img_path,
                displayUrl: getImagePath(img.img_path),
            }));
            window.dispatchEvent(new CustomEvent('ai-images-ready', { detail: { images } }));
        } catch {
            window.dispatchEvent(new CustomEvent('ai-images-ready', { detail: { images: [] } }));
        }
    };

    // Step 1c: AI stream finished — fire pending suggestions fetch if category already selected
    const handleAIStreamDone = (aiData) => {
        streamDoneRef.current = true;
        if (pendingSuggestionsRef.current) {
            const { specsData, categoryName, productName, keywordId } = pendingSuggestionsRef.current;
            pendingSuggestionsRef.current = null;
            fetchSuggestionsWithSpecs(specsData, aiData, categoryName, productName, keywordId);
        }
    };

    // Step 2: User picked a category → buffer cat data, still fetch specs/images for chatbot display
    const handleAICategorySelected = async (categoryName, aiData) => {
        const fireSpecsReady = (mapped = [], unmapped = []) =>
            window.dispatchEvent(new CustomEvent('ai-specs-ready', { detail: { mapped, unmapped } }));

        const isService = bufferedRef.current.fieldFills.some(f => f.fieldKey === 'categoryType' && f.value === 'service');

        try {
            if (!bgSpecsCacheRef.current[categoryName]) {
                bgSpecsCacheRef.current[categoryName] = fetchCategorySpecs(categoryName, isService);
            }
            const { cat, specsData, categoryStatus } = await bgSpecsCacheRef.current[categoryName];

            if (categoryStatus === 'HARD') return false;

            if (!cat) {
                console.warn('[AI] No category found for:', categoryName);
                window.dispatchEvent(new CustomEvent('ai-specs-ready', { detail: { mapped: [], unmapped: [], isUpdate: true, unfilledMandatory: [] } }));
                window.dispatchEvent(new CustomEvent('ai-spec-suggestions-ready', { detail: { specs: [] } }));
                return;
            }

            // Buffer category data — dispatch to Redux when user clicks Edit Product or Save Product
            bufferedRef.current.catData = { cat, mapped: [], unmapped: [], specsData };

            fireSpecsReady([], []);
            fetchCategoryImages(cat.id);

            // Fire brand suggestions from the brand spec's s_type_options for this category
            const brandSpec = specsData.find(s => (s.s_nm || '').toLowerCase() === 'brand' || Number(s.s_id) === 122);
            if (brandSpec?.s_type_options?.length) {
                window.dispatchEvent(new CustomEvent('ai-brands-ready', { detail: { brands: brandSpec.s_type_options } }));
            }

            const catName = cat?.name || categoryName;
            const productName = aiData?.product || aiData?.productName || bufferedRef.current.productName || '';

            getSpecsFromAI(specsData, productName, catName).then(({ mapped: aiMapped, unmapped: aiUnmapped, unfilledMandatory = [] }) => {
                if (bufferedRef.current.catData) {
                    bufferedRef.current.catData.mapped   = aiMapped;
                    bufferedRef.current.catData.unmapped = aiUnmapped;
                }
                if (formOpenedByAIRef.current) applySpecConfirm(aiMapped, aiUnmapped);
                window.dispatchEvent(new CustomEvent('ai-specs-ready', { detail: { mapped: aiMapped, unmapped: aiUnmapped, isUpdate: true, unfilledMandatory } }));
            });

            if (streamDoneRef.current) {
                fetchSuggestionsWithSpecs(specsData, aiData, catName, productName, cat.id);
            } else {
                pendingSuggestionsRef.current = { specsData, categoryName: catName, productName, keywordId: cat.id };
            }
        } catch (e) {
            console.error('[AI category select]', e);
            window.dispatchEvent(new CustomEvent('ai-specs-ready', { detail: { mapped: [], unmapped: [], isUpdate: true, unfilledMandatory: [] } }));
            window.dispatchEvent(new CustomEvent('ai-spec-suggestions-ready', { detail: { specs: [] } }));
        }
    };

    // Called after stream is done — polls editablePuvSpecAttributes (populated by AddEditProduct's
    // fetchSpecificationAttributes) so we get the full, correctly-transformed spec list.
    // Falls back to specsData from our own fetchProductSpecsData call if Redux isn't ready yet.
    const fetchSuggestionsWithSpecs = (specsData, aiData, categoryName, productName, keywordId) => {
        const token = props.session.token;
        const IGNORE = new Set(['net_weight','manufacturer','manufactured_details','importer','importers_detail','price','country_of_origin','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date','brand','mrp']);
        const fireEmpty = () => {
            window.dispatchEvent(new CustomEvent('ai-spec-suggestions-ready', { detail: { specs: [] } }));
        };

        const MAX_WAIT_MS = 8000;
        const POLL_MS = 350;
        let elapsed = 0;

        const tryFetch = () => {
            dispatch((_, getState) => {
                const editProduct = getState().products?.editProduct || {};
                const reduxSpecs = getState().productSpecification?.editablePuvSpecAttributes || [];

                // Prefer Redux specs (correctly populated by fetchSpecificationAttributes);
                // fall back to the specs we fetched directly only if Redux isn't loaded yet.
                const specList = reduxSpecs.length ? reduxSpecs : specsData;


                if (!specList.length && elapsed < MAX_WAIT_MS) {
                    elapsed += POLL_MS;
                    setTimeout(tryFetch, POLL_MS);
                    return;
                }

                if (!specList.length) { fireEmpty(); return; }

                const unfilled = specList.filter(s =>
                    !IGNORE.has(s.s_nm?.toLowerCase()) &&
                    s.s_type?.toLowerCase() !== 'fixed' &&
                    !Number(s.s_mandatory) &&
                    !Number(s.s_re_mandatory)
                );
                if (!unfilled.length) { fireEmpty(); return; }

                const resolvedProductName = productName || editProduct.productName || '';
                const resolvedCategoryName = categoryName || editProduct.keywordName || editProduct.categoryName || '';

                const filledSpecs = Object.entries(aiData?.specs || {})
                    .filter(([k]) => !IGNORE.has(k.toLowerCase()))
                    .map(([k, v]) => ({ [k]: v }));

                fetchAiSpecSuggestions({
                    productName: resolvedProductName,
                    categoryName: resolvedCategoryName,
                    specData: unfilled,
                    token,
                    keywordId: keywordId || editProduct.keywordId,
                    unitOfMeasurement: editProduct.unitOfMeasurement,
                    filledSpecs,
                    description: editProduct.description || '',
                    isPricePresent: true,
                    isFromAI: true,
                    clickTrack: () => {},
                    cb: (response) => {
                        const items = (response?.data || []).map(s => ({
                            name: s.spec_name,
                            value: s.spec_values?.[0]?.spec_value || '',
                            unit: s.spec_values?.[0]?.spec_unit || '',
                        }));
                        window.dispatchEvent(new CustomEvent('ai-spec-suggestions-ready', { detail: { specs: items } }));
                    },
                });
            });
        };

        tryFetch();
    };

    // Chatbot callbacks — buffer data, applied all at once when user clicks Edit Product or Save Product

    const handleAISpecConfirm = (mapped, unmapped) => {
        bufferedRef.current.specs = { mapped, unmapped };
    };

    const handleAISpecSuggestionsConfirm = (selectedSpecs) => {
        bufferedRef.current.specSuggestions = selectedSpecs;
    };

    const handleAIFieldFill = (fieldKey, value) => {
        bufferedRef.current.fieldFills.push({ fieldKey, value });
    };

    const handleAIImagesConfirm = (selectedImages) => {
        if (selectedImages?.length) bufferedRef.current.images = selectedImages;
    };

    // Fetch AI description from buffered product/category/spec data
    const handleAIFetchDescription = async () => {
        const b = bufferedRef.current;
        const productName = b.productName || '';
        const categoryName = b.catData?.cat?.name || '';
        if (!productName || !categoryName) return null;

        const specArr = [];
        const mappedSpecs = b.catData?.mapped?.length ? b.catData.mapped : (b.specs?.mapped || []);
        mappedSpecs.forEach(({ sid, value, catKey }) => {
            if (value) specArr.push({ sid, label: catKey || '', value, isCustom: false });
        });
        (b.specSuggestions || []).forEach(({ name, value, unit }) => {
            const fullVal = unit ? `${value} ${unit}` : value;
            if (fullVal) specArr.push({ sid: '', label: name, value: fullVal, isCustom: true });
        });
        if (!specArr.length) return null;

        const queryString =
            `product_name=${encodeURIComponent(productName)}` +
            `&product_category=${encodeURIComponent(categoryName)}` +
            `&spec=${encodeURIComponent(JSON.stringify(specArr.slice(0, 7)))}`;
        try {
            const res = await fetch(`/vendorapis/products/ajax/getAIdesc?${queryString}`)
                .then(r => r.json());
            if (res.errors?.code) return null;
            return res?.results || null;
        } catch {
            return null;
        }
    };

    const handleAIChatbotUploadFiles = (files, onComplete) => {
        if (!files.length) { onComplete([]); return; }
        const results = [];

        uploadMultipleFile({
            imageUrlArr: [],
            data: files,
            variantId: '',
            productId: '',
            isMobile: props.isMobile,
            showToastMessage: props.showToastMessage,
            imgUploadUrl: '/vendorapis/products/image/uploadProductImageForLibrary',
            uploadedFrom: 'image',
            updateImage: (res) => {
                if (res.uploaded && res.imgURL) {
                    results.push({ id: res.galleryId || `img_${results.length}`, imageUrl: res.imgURL, displayUrl: getImagePath(res.imgURL) });
                    if (results.length >= (res.noOfFilesToUpload || files.length)) onComplete(results);
                }
            },
            onErrorCB: () => onComplete(results),
        });
    };

    const handleAIChatbotOpenJdGallery = () => {
        props.togglePhotoSlider({ selectPhotoSlider: true });
    };

    // ── Apply helpers — called by handleAIApplyAndOpen after form opens ──────

    const formatAIValueForSpec = (spec, rawValue) => {
        const type = (spec.s_type || '').toLowerCase();
        let finalValue = rawValue;
        let textboxValue = spec.userInput?.textboxValue || '';

        if (['checkbox', 'checkboxautosuggest'].includes(type)) {
            const valInOptions = spec.s_type_options?.find(o => o.toLowerCase() === String(rawValue).toLowerCase());
            if (valInOptions) {
                finalValue = [{ label: valInOptions, checked: true, key: 0 }];
            } else {
                const otherInOptions = spec.s_type_options?.find(o => o.toLowerCase().includes('other'));
                if (otherInOptions) {
                    finalValue = [{ label: otherInOptions, checked: true, key: 0 }];
                    textboxValue = rawValue;
                } else {
                    finalValue = [{ label: rawValue, checked: true, key: 0 }];
                }
            }
        } else if (['dropdown', 'dropdownautosuggest'].includes(type)) {
            const strVal = String(rawValue);
            // Try exact option match first
            let valInOptions = spec.s_type_options?.find(o => o.toLowerCase() === strVal.toLowerCase());
            // If no exact match, try matching just the numeric part (e.g. "128 GB" against "128")
            if (!valInOptions) {
                const numPart = strVal.match(/^([0-9]+(?:\.[0-9]+)?)/)?.[1];
                if (numPart) valInOptions = spec.s_type_options?.find(o => o.toLowerCase().startsWith(numPart));
            }
            if (valInOptions) {
                finalValue = valInOptions;
            } else {
                const otherInOptions = spec.s_type_options?.find(o => o.toLowerCase().includes('other'));
                if (otherInOptions) {
                    finalValue = otherInOptions;
                    textboxValue = rawValue;
                }
            }
        } else {
            // Textbox / numeric fields: if value is "128 GB" and spec has a unit, store just the number
            const unitMatch = String(rawValue).match(/^([0-9]+(?:\.[0-9]+)?)\s+[a-zA-Z]+$/);
            if (unitMatch && (spec.s_unit || spec.unit)) {
                finalValue = unitMatch[1];
            }
        }
        return { finalValue, textboxValue };
    };

    const applyFieldFill = (fieldKey, value) => {
        if (fieldKey.startsWith('spec_')) {
            const sid = fieldKey.replace('spec_', '');
            const MAX_WAIT_MS = 8000;
            const POLL_MS = 350;
            let elapsed = 0;
            const tryFillSpec = () => {
                dispatch((dispatchFn, getState) => {
                    const currentSpecs = getState().productSpecification?.editablePuvSpecAttributes || [];
                    if (!currentSpecs.length && elapsed < MAX_WAIT_MS) {
                        elapsed += POLL_MS;
                        setTimeout(tryFillSpec, POLL_MS);
                        return;
                    }
                    const idx = currentSpecs.findIndex(s => String(s.s_id) === sid);
                    if (idx !== -1) {
                        const updated = { ...currentSpecs[idx], userInput: { ...currentSpecs[idx].userInput, value } };
                        dispatchFn(handleOnChange({ item: updated, parentIndex: idx }));
                        const syncedSpecs = getState().productSpecification?.editablePuvSpecAttributes || [];
                        if (syncedSpecs.length) {
                            dispatchFn(updateSpecificationData({ savedPuvSpecAttributes: syncedSpecs }));
                        }
                        const p = getState().products?.editProduct || {};
                        const existingSpecs = p.specification || [];
                        const newSpecs = existingSpecs.filter(es => String(es.sid) !== sid);
                        newSpecs.push({ sid, value: [value] });
                        dispatchFn(updateEditProductDetail([{ key: 'specification', value: newSpecs }]));
                    }
                });
            };
            tryFillSpec();
            return;
        }
        if (fieldKey === 'brand') {
            const MAX_WAIT_MS = 8000;
            const POLL_MS = 350;
            let elapsed = 0;
            const tryFillBrand = () => {
                dispatch((dispatchFn, getState) => {
                    const specs = getState().productSpecification?.editablePuvSpecAttributes || [];
                    if (!specs.length && elapsed < MAX_WAIT_MS) {
                        elapsed += POLL_MS;
                        setTimeout(tryFillBrand, POLL_MS);
                        return;
                    }
                    const bMdetails = getState().brandManufacturer || {};
                    const sendDetails = bMdetails.sendDetails || [];
                    const brandIdx = specs.findIndex(s => Number(s.s_id) === 122);
                    if (brandIdx !== -1) {
                        const brandItem = { ...specs[brandIdx], userInput: { ...specs[brandIdx].userInput, value } };
                        dispatchFn(handleOnChange({ item: brandItem, parentIndex: brandIdx }));
                    }
                    const bmData = [...sendDetails];
                    if (bmData[0]) bmData[0] = { ...bmData[0], values: [value] };
                    dispatchFn(updateBrandManufactureDetails({ ...bMdetails, brandName: value, sendDetails: bmData }));
                });
            };
            tryFillBrand();
        } else if (fieldKey === 'manufacturerName' || fieldKey === 'manufacturerAddress') {
            const bmKey = fieldKey === 'manufacturerName' ? 'manufacturer' : 'manufactured_details';
            dispatch((dispatchFn, getState) => {
                const bMdetails = getState().brandManufacturer || {};
                const sendDetails = bMdetails.sendDetails || [];
                const bmData = sendDetails.map(cur =>
                    cur.name === bmKey ? { ...cur, values: [value] } : cur
                );
                dispatchFn(updateBrandManufactureDetails({ ...bMdetails, [bmKey]: value, sendDetails: bmData }));
            });
    } else if (['price_estimate', 'mrp', 'actualPrice', 'sellingPrice'].includes(fieldKey)) {
        dispatch((dispatchFn, getState) => {
            const p = getState().products?.editProduct || {};
            const priceObj = p.priceObj ? { ...p.priceObj } : { isSinglePrice: true };
            const updates = [];
            if (fieldKey === 'actualPrice') {
                priceObj.actualPrice = value;
                updates.push({ key: 'actualPrice', value });
            } else {
                priceObj.singlePrice = value;
                if (fieldKey === 'sellingPrice') {
                    updates.push({ key: 'sellingPrice', value }, { key: 'sellingOnlinePrice', value });
                } else {
                    updates.push({ key: 'mrp', value }, { key: 'sellingOnlinePrice', value }, { key: 'sellingPrice', value });
                }
            }
            updates.push({ key: 'priceObj', value: priceObj });
            dispatchFn(updateEditProductDetail(updates));
        });
        } else if (fieldKey === 'countryOfOrigin') {
            const co = findCountry(value);
            if (co) dispatch(updateEditProductDetail([{
                key: 'countryOrigin',
                value: { name: 'Country Of Origin', values: [co.countryName, co.countryCode || ''], otherFlag: 0 },
            }]));
        } else if (fieldKey === 'businessType') {
            dispatch((dispatchFn, getState) => {
                const existing = getState().products?.editProduct?.bizSuggestion || {};
                dispatchFn(updateEditProductDetail([{ key: 'bizSuggestion', value: { ...existing, bizType: value, natCatId: value } }]));
            });
        } else {
            dispatch(updateEditProductDetail([{ key: fieldKey, value }]));
        }
        window.dispatchEvent(new CustomEvent('ai-field-highlight', { detail: { field: fieldKey, value } }));
    };

    const applySpecConfirm = (mapped, unmapped) => {
        const MAX_WAIT_MS = 8000;
        const POLL_MS = 350;
        let elapsed = 0;
        const tryFill = () => {
            dispatch((dispatchFn, getState) => {
                const currentSpecs = getState().productSpecification?.editablePuvSpecAttributes || [];
                if (!currentSpecs.length && elapsed < MAX_WAIT_MS) {
                    elapsed += POLL_MS;
                    setTimeout(tryFill, POLL_MS);
                    return;
                }
                mapped.forEach(({ sid, value }) => {
                    const idx = currentSpecs.findIndex(s => String(s.s_id) === String(sid));
                    if (idx !== -1) {
                            const spec = currentSpecs[idx];
                            const { finalValue, textboxValue } = formatAIValueForSpec(spec, value);
                            const updated = { ...spec, userInput: { ...spec.userInput, value: finalValue, textboxValue } };
                            if (textboxValue) {
                                updated.isDependentTextBox = true;
                                updated.textBoxIsHidden = true;
                            }
                        dispatchFn(handleOnChange({ item: updated, parentIndex: idx }));
                    }
                });
                if (mapped.length) {
                    const preDefinedSpecs = mapped.map(({ sid, value }) => ({ sid, value: [value] }));
                    dispatchFn(updateEditProductDetail([{ key: 'specification', value: preDefinedSpecs }]));
                }
                const syncedSpecs = getState().productSpecification?.editablePuvSpecAttributes || [];
                if (syncedSpecs.length) {
                    dispatchFn(updateSpecificationData({ savedPuvSpecAttributes: syncedSpecs }));
                }
                if (unmapped.length) {
                    const existing = getState().productSpecification?.savedCustomSpecAttributes || [];
                    const newCustom = unmapped.map(({ key, value }) => ({
                        key: { value: key, displayValue: key },
                        value: { value, displayValue: value },
                    }));
                    dispatchFn(updateSpecificationData({ savedCustomSpecAttributes: [...existing, ...newCustom] }));
                }
            });
        };
        tryFill();
    };

    const applySpecSuggestionsConfirm = (selectedSpecs) => {
        const MAX_WAIT_MS = 5000;
        const POLL_MS = 350;
        let elapsed = 0;
        const tryFill = () => {
            dispatch((dispatchFn, getState) => {
                const currentSpecs = getState().productSpecification?.editablePuvSpecAttributes || [];
                if (!currentSpecs.length && elapsed < MAX_WAIT_MS) {
                    elapsed += POLL_MS;
                    setTimeout(tryFill, POLL_MS);
                    return;
                }
                selectedSpecs.forEach(({ name, value }) => {
                    const idx = currentSpecs.findIndex(s =>
                        s.s_dnm?.toLowerCase() === name?.toLowerCase() ||
                        s.s_nm?.toLowerCase() === name?.toLowerCase()
                    );
                    if (idx !== -1) {
                            const spec = currentSpecs[idx];
                            const { finalValue, textboxValue } = formatAIValueForSpec(spec, value);
                            const updated = { ...spec, userInput: { ...spec.userInput, value: finalValue, textboxValue } };
                            if (textboxValue) {
                                updated.isDependentTextBox = true;
                                updated.textBoxIsHidden = true;
                            }
                        dispatchFn(handleOnChange({ item: updated, parentIndex: idx }));
                    }
                });
                const syncedSpecs = getState().productSpecification?.editablePuvSpecAttributes || [];
                if (syncedSpecs.length) {
                    dispatchFn(updateSpecificationData({ savedPuvSpecAttributes: syncedSpecs }));
                }
            });
        };
        tryFill();
    };

    // Validate mandatory fields + apply everything + open form + trigger save
    const handleAISaveProduct = async (description, onSaveStart) => {
        const b = bufferedRef.current;
        const missing = [];
        if (!b.productName) missing.push('Product Name');
        if (!b.catData) missing.push('Category');
        if (!b.images?.length) missing.push('Product Image');
        const hasPrice = b.fieldFills.some(f => f.fieldKey === 'mrp' || f.fieldKey === 'price_estimate' || f.fieldKey === 'sellingPrice' || f.fieldKey === 'actualPrice');
        if (!hasPrice) missing.push('Price');

        const hasBizType = b.fieldFills.some(f => f.fieldKey === 'businessType');
        if (!hasBizType && !props.session?.businessType) missing.push('BusinessType');

        const rawSpecs = b.catData?.specsData || [];
        const filledSpecSids = new Set();
        const { mapped: mappedSpecs } = getMappedUnmapped(b);
        mappedSpecs.forEach(m => filledSpecSids.add(String(m.sid)));
        (b.specSuggestions || []).forEach(s => {
            const match = rawSpecs.find(rs => rs.s_dnm?.toLowerCase() === s.name?.toLowerCase() || rs.s_nm?.toLowerCase() === s.name?.toLowerCase());
            if (match) filledSpecSids.add(String(match.s_id));
        });
        b.fieldFills.forEach(f => {
            if (f.fieldKey.startsWith('spec_')) {
                filledSpecSids.add(f.fieldKey.replace('spec_', ''));
            }
        });

        const IGNORE_SPECS = new Set(['brand','manufacturer','manufactured_details','importer','importers_detail','price','country_of_origin','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date']);

        rawSpecs.forEach(spec => {
            if (IGNORE_SPECS.has((spec.s_nm || '').toLowerCase())) return;
            const isMandatory = Number(spec.s_mandatory) || Number(spec.s_re_mandatory);
            if (isMandatory && spec.s_type?.toLowerCase() !== 'fixed' && !filledSpecSids.has(String(spec.s_id))) {
                missing.push(`Spec: ${spec.s_dnm || spec.s_nm}|${spec.s_id}`);
            }
        });

        if (missing.length) return missing;

        // All mandatory fields present — background auto-save
        const savedBuffer = { ...b, fieldFills: [...b.fieldFills] };
        bufferedRef.current = { productName: null, catData: null, fieldFills: [], specs: null, specSuggestions: null, images: null };
        formOpenedByAIRef.current = false;

        if (onSaveStart) onSaveStart();

        return new Promise((resolve) => {
            dispatch(showHideLoader({ showLoader: true }));
            setTimeout(() => {
            unstable_batchedUpdates(() => {
                dispatch({ type: 'INIT_ADD_PRODUCT', payload: { selectedProductType: 'product' } });
                dispatch(hideProductEditSlider());
            });

            setTimeout(() => {
                const updates = buildBaseUpdates(savedBuffer, description);
                const specs = [];
                const customAttrs = [];
                let mrp = '';
                const brandManuf = { brandName: '', manufacturer: '', manufactured_details: '' };
                const rawSpecsData = savedBuffer.catData?.specsData || [];

                const addSpec = (sid, name, value, isCustom = 0) => {
                    specs.push({ s_name: name, name, values: [value], value, sid: String(sid), isCustom });
                };

                savedBuffer.fieldFills.forEach(({ fieldKey, value }) => {
                    if (fieldKey.startsWith('spec_')) {
                        const sid = fieldKey.replace('spec_', '');
                        const match = rawSpecsData.find(rs => String(rs.s_id) === String(sid));
                        addSpec(sid, match?.s_dnm || match?.s_nm || '', value);
                    } else if (['mrp', 'price_estimate'].includes(fieldKey)) {
                        mrp = value;
                    } else if (fieldKey === 'actualPrice') {
                        updates.push({ key: 'actualPrice', value });
                        const pIdx = updates.findIndex(u => u.key === 'priceObj');
                        if (pIdx > -1) updates[pIdx].value.actualPrice = value;
                        else updates.push({ key: 'priceObj', value: { isSinglePrice: true, actualPrice: value } });
                    } else if (fieldKey === 'sellingPrice') {
                        updates.push({ key: 'sellingPrice', value }, { key: 'sellingOnlinePrice', value });
                        const pIdx = updates.findIndex(u => u.key === 'priceObj');
                        if (pIdx > -1) updates[pIdx].value.singlePrice = value;
                        else updates.push({ key: 'priceObj', value: { isSinglePrice: true, singlePrice: value } });
                    } else if (fieldKey === 'brand') {
                        brandManuf.brandName = value;
                    } else if (fieldKey === 'manufacturerName') {
                        brandManuf.manufacturer = value;
                    } else if (fieldKey === 'manufacturerAddress') {
                        brandManuf.manufactured_details = value;
                    } else if (fieldKey === 'countryOfOrigin') {
                        const co = findCountry(value);
                        if (co) updates.push({ key: 'countryOrigin', value: { name: 'Country Of Origin', values: [co.countryName, co.countryCode || ''], otherFlag: 0 } });
                    } else if (fieldKey === 'businessType') {
                        // saveAddEditProduct reads editProduct.bizSuggestion.bizType, not bizTypeData
                        const bizSugIdx = updates.findIndex(u => u.key === 'bizSuggestion');
                        if (bizSugIdx !== -1) {
                            updates[bizSugIdx] = { key: 'bizSuggestion', value: { ...updates[bizSugIdx].value, bizType: value, natCatId: value } };
                        } else {
                            updates.push({ key: 'bizSuggestion', value: { bizType: value, natCatId: value } });
                        }
                    } else {
                        updates.push({ key: fieldKey, value });
                    }
                });

                const { mapped: mappedSpecsToApply, unmapped: unmappedSpecsToApply } = getMappedUnmapped(savedBuffer);

                mappedSpecsToApply.forEach(({ sid, value, catKey }) => {
                    if (!specs.find(s => String(s.sid) === String(sid))) {
                        const match = rawSpecsData.find(rs => String(rs.s_id) === String(sid));
                        addSpec(sid, catKey || match?.s_dnm || match?.s_nm || '', value);
                    }
                });

                (savedBuffer.specSuggestions || []).forEach(({ name, value }) => {
                    const match = rawSpecsData.find(rs => rs.s_dnm?.toLowerCase() === name?.toLowerCase() || rs.s_nm?.toLowerCase() === name?.toLowerCase());
                    if (match && !specs.find(s => String(s.sid) === String(match.s_id))) {
                        addSpec(match.s_id, match.s_dnm || match.s_nm || name, value);
                    }
                });

                unmappedSpecsToApply.forEach(({ key, value }) => {
                    addSpec('', key, value, 1);
                    customAttrs.push({ name: key, value, key: Date.now() + Math.random() });
                });

                if (specs.length) updates.push({ key: 'specification', value: specs });
                if (customAttrs.length) updates.push({ key: 'customAttrs', value: customAttrs });
                if (mrp) updates.push(
                    { key: 'mrp',                value: mrp },
                    { key: 'sellingOnlinePrice', value: mrp },
                    { key: 'sellingPrice',        value: mrp },
                    { key: 'priceObj',            value: { isSinglePrice: true, singlePrice: mrp } }
                );

                dispatch(updateEditProductDetail(updates));
                dispatchBrandManuf(brandManuf);

                let saveFired = false;
                const doSave = () => {
                    if (saveFired) return;
                    saveFired = true;
                    dispatch(saveAddEditProduct({ productId: 'ADD_PRODUCT' }, (response) => {
                        dispatch(showHideLoader({ showLoader: false }));
                        if (response?.isSuccess) {
                            const successMsg = response.msg || response.data?.msg || 'Product saved successfully!';
                            const isIssue = !/success|added|updated/i.test(successMsg);
                            dispatch(showToastMessage({ message: successMsg, type: isIssue ? 'error' : 'info' }));
                            if (isIssue) bufferedRef.current = savedBuffer;
                            resolve({ success: true, msg: successMsg, issue: isIssue });
                        } else {
                            bufferedRef.current = savedBuffer;
                            const errorMsg = response?.error_msg || response?.errors?.msg || response?.msg || response?.data?.msg || response?.message || '';
                            resolve({ success: false, errorMsg });
                        }
                    }));
                };

                if (savedBuffer.images?.some(img => !img.imageUrl)) {
                    const fallback = setTimeout(doSave, 6000);
                    dispatchImages(savedBuffer.images, () => { clearTimeout(fallback); setTimeout(doSave, 300); });
                } else {
                    setTimeout(doSave, 800);
                }
            }, 100);
        }, 400);
        });
    };

    // Apply everything + open form + close chatbot
    const handleAIApplyAndOpen = (description, { skipHistoryBack = false } = {}) => {
        const b = bufferedRef.current;
        bufferedRef.current = { productName: null, catData: null, fieldFills: [], specs: null, specSuggestions: null, images: null };
        formOpenedByAIRef.current = true;

        if (!skipHistoryBack) window.history.back();

        setTimeout(() => {
            dispatch(getProductData({ productId: 'ADD_PRODUCT' }));

            setTimeout(() => {
                const updates = buildBaseUpdates(b, description);
                dispatch(updateEditProductDetail(updates));
                window.dispatchEvent(new CustomEvent('ai-field-highlight', { detail: { field: 'productName' } }));

                b.fieldFills.forEach(({ fieldKey, value }) => applyFieldFill(fieldKey, value));

                const { mapped, unmapped } = getMappedUnmapped(b);
                if (mapped.length || unmapped.length) applySpecConfirm(mapped, unmapped);

                if (b.specSuggestions?.length) applySpecSuggestionsConfirm(b.specSuggestions);

                if (b.images?.some(img => !img.imageUrl)) {
                    dispatchImages(b.images);
                }
            }, 400);
        }, 400);
    };

	return (
        <div className={(!profileObject.isRE && profileObject.isSO && !profileObject.isSer) ? 'sell-online-profile':''}>
            {!props.isReadOnly && props.actualProdCount || props.tabKey == 'brand' ? 
                <AddDCButton
                    iconData = {iconData.current}
                    viaOmni={props.session?.viaOmni}
                    actualProdCount={props.actualProdCount || 0}
                    profileObject={profileObject}
                    isAddEditButtonAnimation={props.isAddEditButtonAnimation}
                    hasGlassFooter={props.hasGlassFooter}
                />
             : (!props.tabKey && props.showNoProdPage && !props.productShimmer ? <NoProductServiceIdeal
                    clickHandler={handleOptionClick}

              /> : null)
            }
            
            <FileSelector
                accept={accept.join()}
                onChange={(fileData) => {
                    if(isBrochure){
                        onChangeBrochure(fileData);
                        setForBrochure(false);
                    }else {
                        onFileChange(fileData);
                    }
                }}
                ref={fileSelector}
            />

            {ublcsModal && (
			<UblcsModal
				onHidden={() => toggleUblcsModal(false)}
			/>
			)}

            {showAIAssistant && (
                <AIAssistantModal
                    isMobile={props.isMobile}
                    onHidden={() => setShowAIAssistant(false)}
                    countryList={props.countryList}
                    bizTypeRequired={!props.session?.businessType}
                    onOpenAddProduct={handleAIProductNameSet}
                    onCategorySelected={handleAICategorySelected}
                    onStreamDone={handleAIStreamDone}
                    onFieldFill={handleAIFieldFill}
                    onSpecConfirm={handleAISpecConfirm}
                    onSpecSuggestionsConfirm={handleAISpecSuggestionsConfirm}
                    onImagesConfirm={handleAIImagesConfirm}
                    onUploadImageFiles={handleAIChatbotUploadFiles}
                    onOpenJdGallery={handleAIChatbotOpenJdGallery}
                    onFetchDescription={handleAIFetchDescription}
                    onSaveProduct={handleAISaveProduct}
                    onApplyAndOpen={handleAIApplyAndOpen}
                />
            )}
        </div>
	);
};

const mapStateToProps = (state, props) => {
    return{
        ...props,
        supplierId: state.session.supplierId,
        vendorImages: state.products.vendorImages,
        isMobile: state.deviceData.isMobile,
        selectPhotoSlider: state.photosGallery.selectPhotoSlider,
        source: state.session.source,
        user: state.session.user,
        session: state.session,
        fileAttachmentArr: state.products.brochureAttachment.fileAttachments,
        tabKey: state.products.tabKey,
        actualProdCount: state.products.listing.actualProdCount,
        allResultsFetched: state.products.listing.allResultsFetched,
        showNoProdPage: state.products.listing.showNoProdPage && !parseInt(state.products.listing?.actualProdCount),
        isAddEditButtonAnimation: state.products.isAddEditButtonAnimation,
        isJdBusinessIOS: state.session.isJdBusinessIOS,
        appVersion: state.session.appVersion,
	    hasGlassFooter: state.session.hasGlassFooter,
	    appVersion: state.session.appVersion,
        isReadOnly: state.session.isReadOnly,
        countryList: state.products.countryList || [],
    }
}

export default withRipple(connect(mapStateToProps, {
    setRedirectedFrom,
    updateItemImage,
    getVendorImages,
    setVendorImages,
    toggleGalleryModal,
    showToastMessage,
    showHideLoader,
    togglePhotoSlider,
    markPreviouslyUploadedFiles,
    setTabStatus,
    setPreviousTabIndex,
    activateBrochureTab,
    setCurrentStep,
    toggleAICreationModal,
    getProductData

})(AddPhotoProdButton));
